module.exports = __webpack_public_path__ + "img/homeBg.a248bf65.png";